import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { useCallback as u } from "react";
import { S as C } from "../../down-arrow-CNVCC5Vu.js";
import { Button as h } from "../../shared/button/Button.component.js";
import { ButtonThemeEnum as w } from "../../shared/button/types.js";
import { Dropdown as e } from "../../shared/dropdown/Dropdown.component.js";
import { useMergeThemeVariables as b } from "../../shared/utils.js";
import '../../assets/Card.css';const k = "_card_1rekt_2", v = "_iconContainer_1rekt_10", f = "_textContainer_1rekt_23", N = "_label_1rekt_27", x = "_value_1rekt_35", B = "_buttonContainer_1rekt_45", M = "_optionsButton_1rekt_45", y = "_icon_1rekt_10", T = "_dropdownMenu_1rekt_63", o = {
  card: k,
  iconContainer: v,
  textContainer: f,
  label: N,
  value: x,
  buttonContainer: B,
  optionsButton: M,
  icon: y,
  dropdownMenu: T
}, D = ({
  icon: r,
  label: a,
  value: s,
  leftPlateOffset: i = 45,
  renderMenuContent: d,
  theme: c
}) => {
  const l = b(
    "dropdown",
    e.themeKeys,
    c
  ), m = u(
    ({ ref: _, onClick: p }) => /* @__PURE__ */ t(
      h,
      {
        theme: w.naked,
        className: o.optionsButton,
        ref: _,
        onClick: p,
        children: /* @__PURE__ */ t(C, { className: o.icon })
      }
    ),
    []
  );
  return /* @__PURE__ */ n("div", { className: o.card, children: [
    /* @__PURE__ */ t("div", { className: o.iconContainer, children: r }),
    /* @__PURE__ */ n("div", { className: o.textContainer, children: [
      /* @__PURE__ */ t("div", { className: o.label, children: a }),
      /* @__PURE__ */ t("div", { className: o.value, children: s })
    ] }),
    /* @__PURE__ */ t("div", { className: o.buttonContainer, children: /* @__PURE__ */ t(
      e,
      {
        theme: l,
        plateMinWidth: 220,
        renderButton: m,
        leftPlateOffset: i,
        topPlateOffset: -40,
        renderMenuContent: d,
        dropdownMenuClass: o.dropdownMenu
      }
    ) })
  ] });
}, F = D;
F.themeKeys = {
  ...e.themeKeys,
  dropdown: !0
};
export {
  F as FlowCard
};
